import React from 'react';
import { UserRoles, IItemForGetShortDishInfo } from 'types';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { DragDropContext, Draggable, Droppable, DropResult } from 'react-beautiful-dnd';
import DraggableSelectedItem from 'components/SelectedItem/DraggableSelectedItem';
import ChunkOfTextWithCopying from 'components/Text/ChunkOfTextWithCopying';
import style from './DnDList.module.scss';

interface IProps {
	setModificationsDishes: (value: string[]) => void;
	removeModificationsDish: (value: string) => void;
	selectedModificationsDishes: string[];
	fetchedModificationsDishes: IItemForGetShortDishInfo[];
}

export const DnDList: React.FC<IProps> = React.memo(
	({ setModificationsDishes, removeModificationsDish, selectedModificationsDishes, fetchedModificationsDishes }) => {
		const hasChangePositionAccess = useRoleAccess([
			UserRoles.SUPER_USER,
			UserRoles.CLIENT_MANAGER,
			UserRoles.GROUP_MANAGER,
			UserRoles.TECHNICAL,
		]);

		const handleDragEnd = (result: DropResult) => {
			if (!selectedModificationsDishes.length || !result.destination) {
				return null;
			}
			const items = selectedModificationsDishes;
			const [reorderedItem] = items.splice(result.source.index, 1);
			items.splice(result.destination.index, 0, reorderedItem);
			setModificationsDishes(items);
		};

		return (
			<DragDropContext onDragEnd={handleDragEnd}>
				<Droppable droppableId="modificationsDishList">
					{(provided) => (
						<div
							className={style.modificationsDishList}
							ref={provided.innerRef}
							{...provided.droppableProps}>
							{selectedModificationsDishes.map((el, index) => {
								const dish = fetchedModificationsDishes.find((fetched) => fetched.id === el);

								return (
									<Draggable key={el} draggableId={el} index={index}>
										{(provided) => (
											<DraggableSelectedItem
												draggableInnerRef={provided.innerRef}
												provided={provided}
												positionNumber={index + 1}
												label={dish?.name || ''}
												onDelete={() => removeModificationsDish(el)}
												hasDragAccess={hasChangePositionAccess}
												additionalContent={
													<>
														{dish?.externalId && (
															<ChunkOfTextWithCopying
																text={dish.externalId}
																className={style.externalId}
															/>
														)}
													</>
												}
											/>
										)}
									</Draggable>
								);
							})}
							{provided.placeholder}
						</div>
					)}
				</Droppable>
			</DragDropContext>
		);
	},
);
